import { render, staticRenderFns } from "./AS_PoshPolicy.vue?vue&type=template&id=63d80b80&scoped=true&"
import script from "./AS_PoshPolicy.vue?vue&type=script&lang=js&"
export * from "./AS_PoshPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AS_PoshPolicy.vue?vue&type=style&index=0&id=63d80b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d80b80",
  null
  
)

export default component.exports